module.exports = __webpack_public_path__ + "images/feature/140926_permission-73c94d1b90cea9ca619aaa55fd285275.jpg";